import { render, staticRenderFns } from "./ModalBatchPay.vue?vue&type=template&id=520a68f4&scoped=true"
import script from "./ModalBatchPay.vue?vue&type=script&lang=js"
export * from "./ModalBatchPay.vue?vue&type=script&lang=js"
import style0 from "./ModalBatchPay.vue?vue&type=style&index=0&id=520a68f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a68f4",
  null
  
)

export default component.exports